/* Velune : fiche produit (offres, guide des tailles, estimation de livraison). */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals') return noDecimals;
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      if (key === 'amount_with_space_separator') return withComma;
      return withDot;
    });
  }

  function initBundle(root) {
    if (root.dataset.vlReady) return;
    root.dataset.vlReady = '1';
    var variants = JSON.parse(root.querySelector('[data-vl-variants-json]').textContent || '[]');
    var colors = {};
    try { colors = JSON.parse(root.querySelector('[data-vl-colors-json]').textContent || '{}'); } catch (e) {}
    var moneyFormat = root.dataset.moneyFormat;
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-vl-offer]'));
    var submit = root.querySelector('[data-vl-submit]');
    var error = root.querySelector('[data-vl-error]');

    var offerIndex = parseInt(root.dataset.offerIndex, 10);
    var itemLabel = root.dataset.itemLabel || 'Collant';

    // Valeurs choisies sur une ligne (sans l'option Offre)
    function rowValues(row) {
      var vals = {};
      row.querySelectorAll('select[data-vl-option]').forEach(function (s) { vals[s.dataset.vlOption] = s.value; });
      return vals;
    }

    // Variante qui correspond à une ligne ; offerValue force la valeur de l'option Offre
    function findVariant(row, offerValue) {
      var vals = row ? rowValues(row) : {};
      return variants.find(function (v) {
        return v.options.every(function (o, i) {
          if (i === offerIndex) return offerValue ? o === offerValue : true;
          return vals[i] === undefined || vals[i] === o;
        });
      });
    }

    function rowText(row) {
      return Array.prototype.map.call(row.querySelectorAll('select[data-vl-option]'), function (s) { return s.value; }).join(' / ');
    }

    function paintSwatches(offer) {
      offer.querySelectorAll('select[data-vl-color]').forEach(function (sel) {
        var dd = sel.closest('[data-vl-dd]');
        if (!dd) return;
        var sw = dd.querySelector('[data-vl-swatch]');
        if (sw) sw.style.background = colors[sel.value] || '#000';
        var label = dd.querySelector('[data-vl-dd-label]');
        if (label) label.textContent = sel.value;
        dd.querySelectorAll('[role="option"]').forEach(function (li) { li.setAttribute('aria-selected', li.dataset.value === sel.value ? 'true' : 'false'); });
      });
    }
    root.querySelectorAll('[data-vl-dot]').forEach(function (d) { d.style.background = colors[d.dataset.vlDot] || '#000'; });

    // Menu des couleurs avec pastilles (comme Kaching)
    function closeAll(except) {
      root.querySelectorAll('[data-vl-dd]').forEach(function (dd) {
        if (dd === except) return;
        dd.querySelector('[data-vl-dd-list]').hidden = true;
        dd.querySelector('[data-vl-dd-btn]').setAttribute('aria-expanded', 'false');
      });
    }
    root.querySelectorAll('[data-vl-dd]').forEach(function (dd) {
      var btn = dd.querySelector('[data-vl-dd-btn]');
      var list = dd.querySelector('[data-vl-dd-list]');
      var sel = dd.querySelector('select');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        closeAll(dd);
        list.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('[role="option"]');
        if (!li) return;
        e.stopPropagation();
        sel.value = li.dataset.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function () { closeAll(null); });

    function refreshPrice(offer) {
      var rows = offer.querySelectorAll('[data-vl-row]');
      var paid = parseInt(offer.dataset.paid, 10) || 1;
      var free = parseInt(offer.dataset.free, 10) || 0;
      var value = offer.dataset.value;
      var v = findVariant(rows[0], value || (offerIndex >= 0 ? variants[0].options[offerIndex] : null));
      if (!v) return;
      var p, c;
      if (value) { p = v.price; c = v.compare > v.price ? v.compare : 0; }
      // Lot avec articles offerts : prix barré = prix barré unitaire x nombre d'articles (comme Ophélie)
      else { p = v.price * paid; c = free > 0 ? Math.max(v.compare, v.price) * (paid + free) : (v.compare > v.price ? v.compare * paid : 0); }
      var price = offer.querySelector('[data-vl-price]');
      var compare = offer.querySelector('[data-vl-compare]');
      if (price) price.textContent = formatMoney(p, moneyFormat);
      if (compare) compare.textContent = c ? formatMoney(c, moneyFormat) : '';
    }

    function select(offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-selected', on);
        var head = o.querySelector('[role="radio"]');
        if (head) head.setAttribute('aria-checked', on ? 'true' : 'false');
        var vars = o.querySelector('[data-vl-variants]');
        if (vars) vars.hidden = !on;
      });
      if (error) error.hidden = true;
    }

    offers.forEach(function (offer) {
      paintSwatches(offer);
      refreshPrice(offer);
      offer.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        select(offer);
      });
      var head = offer.querySelector('[role="radio"]');
      if (head) head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(offer); }
      });
      offer.querySelectorAll('select').forEach(function (s) {
        s.addEventListener('change', function () { paintSwatches(offer); refreshPrice(offer); if (error) error.hidden = true; });
      });
    });

    if (!submit) return;
    submit.addEventListener('click', function () {
      var offer = root.querySelector('[data-vl-offer].is-selected') || offers[0];
      var rows = Array.prototype.slice.call(offer.querySelectorAll('[data-vl-row]'));
      var value = offer.dataset.value;
      var items = [];
      var missing = false;
      if (value) {
        // Lot : 1 article de la variante « offre » (prix du lot), les leggings suivants en propriétés
        var v = findVariant(rows[0], value);
        if (!v || !v.available) missing = true;
        else {
          var props = { _Offre: offer.dataset.title };
          rows.slice(1).forEach(function (row, i) { props[itemLabel + ' ' + (i + 2)] = rowText(row); });
          items.push({ id: v.id, quantity: 1, properties: props });
        }
      } else if (rows.length) {
        // Un article par legging, chacun sur sa ligne (comme Luveon) : la réduction automatique offre le 2e
        var base = offerIndex >= 0 ? variants[0].options[offerIndex] : null;
        rows.forEach(function (row, i) {
          var rv = findVariant(row, base);
          if (!rv || !rv.available) { missing = true; return; }
          var props = { _Offre: offer.dataset.title };
          if (rows.length > 1) props._Ligne = String(i + 1);
          items.push({ id: rv.id, quantity: 1, properties: props });
        });
      } else {
        var total = (parseInt(offer.dataset.paid, 10) || 1) + (parseInt(offer.dataset.free, 10) || 0);
        items.push({ id: variants[0].id, quantity: total, properties: { _Offre: offer.dataset.title } });
      }
      if (missing || !items.length) {
        error.textContent = 'Cette combinaison n’est pas disponible. Choisissez une autre taille ou teinte.';
        error.hidden = false;
        return;
      }
      submit.setAttribute('aria-busy', 'true');
      // Tiroir panier de Dawn présent : on l'ouvre (comme Luveon), sinon page panier
      var drawer = document.querySelector('cart-drawer');
      // Cadeau du panier (sac de lavage) ajouté avec le lot ; vlGiftSync corrige ensuite la quantité
      var giftId = drawer && parseInt(drawer.dataset.vlGift, 10);
      var units = items.reduce(function (s, it) { return s + it.quantity; }, 0);
      if (giftId && units >= (parseInt(drawer.dataset.vlGiftMin, 10) || 2)) items.push({ id: giftId, quantity: 1 });
      var payload = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Erreur');
          if (drawer && drawer.renderContents && res.d.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.d);
            submit.removeAttribute('aria-busy');
            if (window.vlGiftSync) window.vlGiftSync();
          } else {
            window.location.href = root.dataset.cartUrl;
          }
        })
        .catch(function (err) {
          submit.removeAttribute('aria-busy');
          error.textContent = err.message;
          error.hidden = false;
        });
    });
  }

  function initModals(scope) {
    scope.querySelectorAll('[data-vl-modal-open]').forEach(function (btn) {
      if (btn.dataset.vlReady) return;
      btn.dataset.vlReady = '1';
      var modal = document.getElementById(btn.dataset.vlModalOpen);
      if (!modal) return;
      document.body.appendChild(modal);
      function close() { modal.hidden = true; document.body.classList.remove('vl-modal-open'); }
      btn.addEventListener('click', function () { modal.hidden = false; document.body.classList.add('vl-modal-open'); });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-vl-modal-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  }

  function initEta(root) {
    var numeric = root.dataset.dateStyle !== 'short';
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    var fmt = function (d, year) {
      if (!numeric) return d.toLocaleDateString('fr-CA', { day: 'numeric', month: 'short' });
      return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + (year ? '/' + d.getFullYear() : '');
    };
    var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
    var n = function (k) { return parseInt(root.dataset[k], 10) || 0; };
    var sep = numeric ? ' - ' : ' au ';
    var range = function (a, b, year) { return a === b ? fmt(add(a), year) : fmt(add(a), year) + sep + fmt(add(b), year); };
    var set = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
    var big = root.querySelector('[data-vl-eta-range]');
    var shipOnly = big && big.dataset.range === 'ship';
    set('[data-vl-eta-range]', shipOnly ? range(n('shipMin'), n('shipMax'), true) : range(n('deliverMin'), n('deliverMax'), true));
    set('[data-vl-eta-today]', fmt(new Date()));
    set('[data-vl-eta-ship]', range(n('shipMin'), n('shipMax')));
    set('[data-vl-eta-deliver]', range(n('deliverMin'), n('deliverMax')));
  }


  // Guide des tailles : questionnaire (taille EU ou mesures) + tableau
  function initSizeGuide(root) {
    if (root.dataset.vlReady) return;
    root.dataset.vlReady = '1';
    var rows = Array.prototype.map.call(root.querySelectorAll('[data-vl-sg-row]'), function (tr) {
      var c = Array.prototype.map.call(tr.children, function (td) { return td.textContent.trim(); });
      var nums = function (txt) { return (txt.match(/\d+(?:[.,]\d+)?/g) || []).map(function (n) { return parseFloat(n.replace(',', '.')); }); };
      return { size: c[0], eu: nums(c[1] || ''), m1: nums(c[2] || ''), m2: nums(c[3] || '') };
    });
    var result = root.querySelector('[data-vl-sg-result]');
    var sizeEl = root.querySelector('[data-vl-sg-size]');
    function show(size) { if (!size) return; sizeEl.textContent = size; result.hidden = false; }
    function idxFor(list, key, v) {
      for (var i = 0; i < list.length; i++) { var r = list[i][key]; if (r.length && v <= r[r.length - 1]) return i; }
      return list.length - 1;
    }
    root.querySelectorAll('[data-vl-sg-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('[data-vl-sg-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-vl-sg-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.vlSgPanel === tab.dataset.vlSgTab); });
      });
    });
    root.querySelectorAll('[data-vl-sg-eu]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        root.querySelectorAll('[data-vl-sg-eu]').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        var v = parseInt(pill.dataset.vlSgEu, 10);
        show(rows.length ? rows[idxFor(rows, 'eu', v)].size : '');
      });
    });
    var toggle = root.querySelector('[data-vl-sg-detail-toggle]');
    var detail = root.querySelector('[data-vl-sg-detail]');
    if (toggle) toggle.addEventListener('click', function () { detail.hidden = !detail.hidden; });
    root.querySelectorAll('[data-vl-sg-measure]').forEach(function (input) {
      input.addEventListener('input', function () {
        var a = parseFloat(root.querySelector('[data-vl-sg-measure="1"]').value);
        var b = parseFloat(root.querySelector('[data-vl-sg-measure="2"]').value);
        var i = -1;
        if (a) i = Math.max(i, idxFor(rows, 'm1', a));
        if (b) i = Math.max(i, idxFor(rows, 'm2', b));
        if (i >= 0) show(rows[i].size);
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-vl-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-vl-eta]').forEach(initEta);
    document.querySelectorAll('[data-vl-sg]').forEach(initSizeGuide);
    initModals(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
